<template>
  <Component
    :is="canDelete && maxSmall ? Swipeable : Primitive"
    class="border-t first-of-type:border-t-0 md:border border-secondary md:rounded-sm"
    v-bind="
      maxSmall
        ? {
            onRight: () => $emit('delete'),
          }
        : { asChild: true }
    "
  >
    <TaskLog
      :item="item"
      :type="type"
      :canDelete="canDelete"
      :class="props.class"
      @delete="$emit('delete')"
    />
    <template #right>
      <Action variant="right" color="error" iconName="delete" />
    </template>
  </Component>
</template>

<script setup>
import { Primitive } from "radix-vue";
import { Action, Swipeable } from "@/SharedComponents/Swipeable";
import { TaskLog } from "@/SharedComponents/Tasks/TaskDetailsParts";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["delete"]);

const props = defineProps({
  item: { type: Object, required: true },
  type: {
    type: String,
    validator: (value) => ["time", "material"].includes(value),
    required: true,
  },
  canDelete: { type: Boolean, required: false },
  class: { type: null, required: false },
});
</script>
